<script>
export default {
    props: {
        active: {
            type: Boolean,
            required: true,
        },
        image: {
            type: String,
            default: null,
        },
    },
};
</script>

<template>
    <button
        :class="{ active }"
        class="flex items-center py-1"
        @click="$emit('click')"
    >
        <div
            class="checkbox-input mr-2"
            :class="{ 'has-image': image }"
            :style="image ? { backgroundImage: `url(${image})`, backgroundSize: 'cover' } : {}"
        >
            <span
                v-if="active"
                class="checkbox-check"
            >&check;</span>
        </div>
        <slot />
    </button>
</template>

<style scoped lang="scss">
button {
    @apply text-grey-darkest text-sm;

    &.active {
        @apply text-primary;
    }
}

.checkbox-input {
    @apply rounded border border-grey-dark flex items-center justify-center w-5 h-5 bg-center bg-no-repeat;
    transition: border-color 0.2s ease, background-color 0.2s ease;
}

.checkbox-input.has-image {
    @apply rounded-full;
}

button.active .checkbox-input:not(.has-image) {
    @apply border-primary bg-primary;
}

button.active .checkbox-input.has-image {
    @apply border-primary;
    box-shadow: inset 0 0 0 2px white;
}

.checkbox-check {
    @apply text-white font-bold leading-none;
    text-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
}
</style>
